import I18n from 'I18n';
import { UserTicketStatusOption, UserTicketViewOption } from '../data/types';
import { getDateRangeDescription } from '../utils/getDateRangeDescription';
export let DateFilterType;
(function (DateFilterType) {
  DateFilterType["TODAY"] = "today";
  DateFilterType["YESTERDAY"] = "yesterday";
  DateFilterType["LAST_7_DAYS"] = "last_7_days";
  DateFilterType["LAST_30_DAYS"] = "last_30_days";
  DateFilterType["THIS_WEEK"] = "this_week";
  DateFilterType["THIS_MONTH"] = "this_month";
  DateFilterType["LAST_MONTH"] = "last_month";
  DateFilterType["THIS_QUARTER"] = "this_quarter";
  DateFilterType["LAST_QUARTER"] = "last_quarter";
  DateFilterType["YEAR_TO_DATE"] = "year_to_date";
  DateFilterType["ALL_TIME"] = "all_time";
})(DateFilterType || (DateFilterType = {}));
export const DEFAULT_FILTER_VALUES = {
  statusFilter: UserTicketStatusOption.ALL,
  ticketView: UserTicketViewOption.PERSONAL,
  createDateFilter: DateFilterType.ALL_TIME,
  lastActivityFilter: DateFilterType.ALL_TIME
};
export const generateStatusFilterOptions = () => [{
  text: I18n.text('customer-portal-app.filter.all'),
  value: UserTicketStatusOption.ALL
}, {
  text: I18n.text('customer-portal-app.filter.open'),
  value: UserTicketStatusOption.OPEN
}, {
  text: I18n.text('customer-portal-app.filter.closed'),
  value: UserTicketStatusOption.CLOSED
}];
export const generateTicketViewFilterOptions = () => [{
  text: I18n.text('customer-portal-app.view.all'),
  value: UserTicketViewOption.COMPANY
}, {
  text: I18n.text('customer-portal-app.view.my'),
  value: UserTicketViewOption.PERSONAL
}];
export const generateDateFilterOptions = () => [{
  text: I18n.text('customer-portal-app.dateFilter.today'),
  value: DateFilterType.TODAY,
  help: getDateRangeDescription(DateFilterType.TODAY)
}, {
  text: I18n.text('customer-portal-app.dateFilter.yesterday'),
  value: DateFilterType.YESTERDAY,
  help: getDateRangeDescription(DateFilterType.YESTERDAY)
}, {
  text: I18n.text('customer-portal-app.dateFilter.last_7_days'),
  value: DateFilterType.LAST_7_DAYS,
  help: getDateRangeDescription(DateFilterType.LAST_7_DAYS)
}, {
  text: I18n.text('customer-portal-app.dateFilter.last_30_days'),
  value: DateFilterType.LAST_30_DAYS,
  help: getDateRangeDescription(DateFilterType.LAST_30_DAYS)
}, {
  text: I18n.text('customer-portal-app.dateFilter.this_week'),
  value: DateFilterType.THIS_WEEK,
  help: getDateRangeDescription(DateFilterType.THIS_WEEK)
}, {
  text: I18n.text('customer-portal-app.dateFilter.this_month'),
  value: DateFilterType.THIS_MONTH,
  help: getDateRangeDescription(DateFilterType.THIS_MONTH)
}, {
  text: I18n.text('customer-portal-app.dateFilter.last_month'),
  value: DateFilterType.LAST_MONTH,
  help: getDateRangeDescription(DateFilterType.LAST_MONTH)
}, {
  text: I18n.text('customer-portal-app.dateFilter.this_quarter'),
  value: DateFilterType.THIS_QUARTER,
  help: getDateRangeDescription(DateFilterType.THIS_QUARTER)
}, {
  text: I18n.text('customer-portal-app.dateFilter.last_quarter'),
  value: DateFilterType.LAST_QUARTER,
  help: getDateRangeDescription(DateFilterType.LAST_QUARTER)
}, {
  text: I18n.text('customer-portal-app.dateFilter.year_to_date'),
  value: DateFilterType.YEAR_TO_DATE,
  help: getDateRangeDescription(DateFilterType.YEAR_TO_DATE)
}, {
  text: I18n.text('customer-portal-app.dateFilter.all_time'),
  value: DateFilterType.ALL_TIME
}];
export const generateDateFilter = (propertyName, type) => {
  if (type === DateFilterType.TODAY) {
    return {
      propertyName,
      start: I18n.moment().startOf('day').toDate().getTime(),
      end: I18n.moment().endOf('day').toDate().getTime()
    };
  }
  if (type === DateFilterType.YESTERDAY) {
    return {
      propertyName,
      start: I18n.moment().subtract(1, 'day').startOf('day').toDate().getTime(),
      end: I18n.moment().subtract(1, 'day').endOf('day').toDate().getTime()
    };
  }
  if (type === DateFilterType.LAST_7_DAYS) {
    return {
      propertyName,
      start: I18n.moment().subtract(7, 'days').startOf('day').toDate().getTime(),
      end: I18n.moment().endOf('day').toDate().getTime()
    };
  }
  if (type === DateFilterType.LAST_30_DAYS) {
    return {
      propertyName,
      start: I18n.moment().subtract(30, 'days').startOf('day').toDate().getTime(),
      end: I18n.moment().endOf('day').toDate().getTime()
    };
  }
  if (type === DateFilterType.THIS_WEEK) {
    return {
      propertyName,
      start: I18n.moment().startOf('week').toDate().getTime(),
      end: I18n.moment().endOf('day').toDate().getTime()
    };
  }
  if (type === DateFilterType.THIS_MONTH) {
    return {
      propertyName,
      start: I18n.moment().startOf('month').toDate().getTime(),
      end: I18n.moment().endOf('month').toDate().getTime()
    };
  }
  if (type === DateFilterType.LAST_MONTH) {
    return {
      propertyName,
      start: I18n.moment().subtract(1, 'month').startOf('month').toDate().getTime(),
      end: I18n.moment().subtract(1, 'month').endOf('month').toDate().getTime()
    };
  }
  if (type === DateFilterType.THIS_QUARTER) {
    return {
      propertyName,
      start: I18n.moment().startOf('quarter').toDate().getTime(),
      end: I18n.moment().endOf('quarter').toDate().getTime()
    };
  }
  if (type === DateFilterType.LAST_QUARTER) {
    return {
      propertyName,
      start: I18n.moment().subtract(1, 'quarter').startOf('quarter').toDate().getTime(),
      end: I18n.moment().subtract(1, 'quarter').endOf('quarter').toDate().getTime()
    };
  }
  if (type === DateFilterType.YEAR_TO_DATE) {
    return {
      propertyName,
      start: I18n.moment().startOf('year').toDate().getTime(),
      end: I18n.moment().endOf('year').toDate().getTime()
    };
  }
  if (type === DateFilterType.ALL_TIME) {
    return null;
  }
};